import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsMantra } from "../../../../data/projects/Mantra/data";
import { projectsshapoorji } from "../../../../data/projects/ShapoorjiPaloonji/data";
import { projectsaheel } from "../../../../data/projects/Saheel/data";

export const SaheelTrendyWest = () => {
  const {
    trendywest: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsaheel;

  return (
    <>
      <Helmet>
        <title>Codename TrendyWest, Tathawade, Pune | Premium 2 & 3 BHK Apartments</title>

        <meta
          name="description"
          content="Explore Codename TrendyWest in Tathawade, Pune – a premium residential project offering stylish 2 & 3 BHK apartments with world-class amenities. Invest in luxury living today!"
        />

        <meta
          name="keywords"
          content="Codename TrendyWest Tathawade, Codename TrendyWest Pune, 2 BHK in Tathawade, 3 BHK flats Tathawade, luxury apartments Pune, new residential projects Pune, Tathawade real estate, premium homes Pune, modern living Tathawade"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/codename-trendywest-tathawade-pune"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
